module.exports = __webpack_public_path__ + "static/media/i_info_metsnew.25ebc403.png";